import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Alert } from 'reactstrap';

export default class PhaseTotalWarning extends React.Component {
    getSummedContractPhases = () => {
        const { job } = this.props;

        const contractPhaseAndQuantities = [];

        job.weekJobResources.forEach((wjr) =>
            wjr.jobContractPhases.forEach((jcp, i) => {
                const targetQuantity = isNaN(jcp.targetQuantity)
                    ? 0
                    : Number(jcp.targetQuantity);

                const contractPhaseAndQuantity =
                    contractPhaseAndQuantities.find(
                        (cpaq) => cpaq.contractPhaseId == jcp.contractPhaseId
                    );

                if (contractPhaseAndQuantity) {
                    contractPhaseAndQuantity.targetQuantity += targetQuantity;
                } else {
                    contractPhaseAndQuantities.push({
                        contractPhaseId: jcp.contractPhaseId,
                        targetQuantity,
                    });
                }
            })
        );

        return contractPhaseAndQuantities;
    };

    getMismatchedContractPhases = () => {
        const { longTermSchedule, contractPhases } = this.props;

        const contractPhaseAndQuantities = this.getSummedContractPhases();

        const mismatchedContractPhases = [];

        contractPhaseAndQuantities.forEach((cpaq) => {
            const scheduledPhase =
                longTermSchedule.longTermScheduleContractPhases.find(
                    (ltscp) => ltscp.contractPhaseId == cpaq.contractPhaseId
                );

            if (!scheduledPhase) {
                mismatchedContractPhases.push({
                    contractPhaseId: cpaq.contractPhaseId,
                    message:
                        'This phase was not specified on the long-term schedule',
                });

                return;
            }

            if (
                Math.abs(scheduledPhase.targetQuantity - cpaq.targetQuantity) >
                0.01
            ) {
                const contractPhase = contractPhases.find(
                    (cp) => cp.id == scheduledPhase.contractPhaseId
                );

                const isLumpSum =
                    contractPhase && contractPhase.unitOfMeasure === 'LS';

                let scheduledQuantity =
                    scheduledPhase.targetQuantity &&
                    scheduledPhase.targetQuantity.toFixed
                        ? scheduledPhase.targetQuantity.toFixed(2)
                        : 0;

                let jobQuantity =
                    cpaq.targetQuantity && cpaq.targetQuantity.toFixed
                        ? cpaq.targetQuantity.toFixed(2)
                        : 0;

                if (isLumpSum) {
                    scheduledQuantity = `${(
                        Number(scheduledQuantity) * 100
                    ).toFixed(2)}%`;

                    jobQuantity = `${(Number(jobQuantity) * 100).toFixed(2)}%`;
                }

                mismatchedContractPhases.push({
                    contractPhaseId: cpaq.contractPhaseId,
                    message: `You have allocated a total target quantity of ${jobQuantity} [[UOM]]; the schedule targeted ${scheduledQuantity} [[UOM]]`,
                });
            }
        });

        return mismatchedContractPhases;
    };

    render() {
        const { longTermSchedule, contractPhases } = this.props;

        if (!longTermSchedule || !contractPhases) {
            return null;
        }

        const mismatchedContractPhases = this.getMismatchedContractPhases();

        if (!mismatchedContractPhases || !mismatchedContractPhases.length) {
            return null;
        }

        return (
            <Alert color="info">
                <div className="d-flex">
                    <div className="float-left mr-2">
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </div>

                    <div>
                        <strong>
                            We noticed the following discrepancies between the
                            target quantities configured on the long-term
                            schedule and what's been allocated for publication.
                        </strong>

                        {mismatchedContractPhases.map((mcp) => {
                            const contractPhase = contractPhases.find(
                                (cp) => mcp.contractPhaseId == cp.id
                            );

                            const unitOfMeasureMessage = mcp.message.replaceAll(
                                '[[UOM]]',
                                contractPhase.unitOfMeasure
                            );

                            const phaseMessage = `${contractPhase.displayPhase} (${contractPhase.description}) - ${unitOfMeasureMessage}.`;

                            return !contractPhase ? null : (
                                <div key={`warning-${mcp.contractPhaseId}`}>
                                    {phaseMessage}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Alert>
        );
    }
}
